<template>
  <div class="tab-description__container">
    <div
      class="tab-description__wrapper"
      ref="observer"
      v-if="descriptions && descriptions.length >= 1 && Object.values(descriptions[0])[0].length"
      :class="{
        'tab-description__wrapper--single': descriptions.length === 1,
        'tab-description__wrapper--full': descriptions[0].html_description,
        'tab-description__wrapper--end': isShow,
        'open': isOpen
      }"
    >
      <with-title
        v-if="descriptions && descriptions.length >= 1 && Object.values(descriptions[0])[0].length"
        :title="$t('product-page__product-description-title')"
        :with-container="descriptions[0].html_description && isDesktop"
      >
        <product-descriptions />
      </with-title>
      <div class="description-hide-trigger"
           v-if="isShow"
           :class="{ 'open': this.isOpen }"
           @click="changeIsOpenStatus">
        <span v-if="!isOpen">{{ $t('product-page__description-open') }}</span>
        <span v-if="isOpen">{{ $t('product-page__description-close') }}</span>
        <svg width="24"
             height="24"
             viewBox="0 0 24 24"
             fill="none"
             xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd"
                clip-rule="evenodd"
                d="M7 9.70588L7.70667 9L12.3 13.5882L16.8933 9L17.6 9.70588L12.3 15L7 9.70588Z"
                fill="#909090"/>
        </svg>
      </div>
    </div>
  </div>
</template>
<script>
import ProductDescriptions from '@/components/product/product-page/ProductDescriptions.vue'
import WithTitle from '@/views/product-page/layouts/WithTitle.vue'

export default {
  name: 'DescriptionWrapper',
  components: { WithTitle, ProductDescriptions },
  data () {
    return {
      isOpen: false,
      isShow: false
    }
  },
  props: {
    descriptions: {
      type: Array,
      default: () => []
    },
    isDesktop: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    changeIsOpenStatus () {
      this.isOpen = !this.isOpen
      if (!this.isOpen) {
        setTimeout(() => {
          const el = document.querySelector('.tab-description__wrapper')
          const y = el.getBoundingClientRect().top + window.scrollY - 65
          window.scrollTo({ top: y, behavior: 'smooth' })
          // el.scrollIntoView({ behavior: 'smooth', block: 'start' })
        }, 350)
      }
    },
    changeIsShow () {
      let el = document.querySelector('.tab-description__wrapper')
      const minHeight = this.isDesktop ? 1200 : 800
      if (el && el.offsetHeight >= minHeight) {
        this.isShow = true
      }
    }
  },
  watch: {
    descriptions: {
      immediate: true,
      handler (val) {
        if (val.length > 0) {
          setTimeout(() => {
            this.changeIsShow()
          }, 200)
        }
      }
    }
  },
  mounted () {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry && entry.isIntersecting) {
        setTimeout(() => {
          this.changeIsShow()
        }, 200)
      }
    })
    if (this.$refs.observer) {
      observer.observe(this.$refs.observer)
    }
  }
}
</script>

<style lang="sass" scoped>
.tab-description__container
  margin-top: 30px
.tab-description__container,
.tab-description__row
  display: flex
  align-items: flex-start
  justify-content: space-between
  position: relative
  flex-flow: column
  width: 100%
  +mmin($tablet)
    flex-flow: row wrap
  &--mt
    margin-top: 30px
    +mmin($tablet)
      margin-top: 80px

.tab-description__wrapper
  width: 100%
  position: relative
  max-height: 800px
  overflow: hidden
  transition: max-height 0.3s

  +mmin($tablet)
    max-height: 1200px
    margin-bottom: 50px !important
  &.open
    max-height: 1000000px
    &:before
      opacity: 0
  &--single
    margin: 0 auto
    max-width: 860px

  &--full
    max-width: 100%
    padding: 0

  &--end
    padding-bottom: 60px !important
    &:before
      content: ''
      position: absolute
      left: 50%
      transform: translateX(-50%)
      bottom: 0
      width: 100vw
      z-index: 1
      height: 100px
      background: linear-gradient(180deg, rgba(255,255,255,0) 0%, rgba(255,255,255,0.75) 13%, rgba(255,255,255,0.95) 25%, rgba(255,255,255,1) 41%, rgba(255,255,255,1) 100%)
      opacity: 1
      transition: opacity 0.2s

.description-hide-trigger
  font-size: 14px
  line-height: 17.6px
  z-index: 2
  color: #333
  font-weight: 500
  padding: 10px 25px 10px 40px
  display: flex
  justify-content: center
  align-items: center
  cursor: pointer
  background-color: #fff
  position: absolute
  bottom: 0
  border-radius: 3px
  border: 1px solid #CCCCCC
  left: 50%
  transform: translateX(-50%)
  width: auto
  +mmax($small)
    width: 100%
  &.open
    svg
      transform: scale(1, -1)
  svg
    margin-left: 5px
</style>
